module.exports = __webpack_public_path__ + "static/media/STS.18709091.jpg";